import { KYMW0800Model } from './../kymw0800.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 実績履歴取得クラス
 *
 * @export GetResultListService
 * @class GetResultListService
 * @extends {PlessResponder}
 */
@Injectable()
export class GetResultListService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW0800Model;
  private vo: any;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetResultListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        FormID: this.vo.formId,
        PCode: this.vo.pCode,
        SortItem: this.vo.sortItem,
        SortOrder: this.vo.sortOrder,
        Page: this.vo.page,
        MakedWKT: this.vo.makedWKT,
        TotalCnt: this.vo.totalCnt
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetResultListService
   */
  execute(model: KYMW0800Model, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('KYMW0800GetResultList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetResultListService
   */
  success(data: any): void {
    this.model.updateResultList(data);
    this.model.kymw0800Component.setEnabledPrevNext();
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
